'use client';

import { differenceInYears } from 'date-fns/differenceInYears';

import { isUnknownYear } from './isUnknownYear';

export function getProfileAge(
  startDateString: string,
  endingDateString?: string,
) {
  const unknownStartYear = isUnknownYear(startDateString);

  if (unknownStartYear) {
    return null;
  }

  const startDate = new Date(
    unknownStartYear ? startDateString.padStart(10, '0') : startDateString,
  );

  const endingDate = endingDateString
    ? new Date(
        isUnknownYear(endingDateString)
          ? endingDateString.padStart(10, '0')
          : endingDateString,
      )
    : new Date();

  const age = differenceInYears(endingDate, startDate);

  return ` (${age} años)`;
}

export function ProfileAge(props: { birthdate: string; deathdate?: string }) {
  return <>{getProfileAge(props.birthdate, props.deathdate)}</>;
}
